import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import clock from '../../../assets/images/clock.svg';
import pin3 from '../../../assets/images/pin3.svg';
import pin4 from '../../../assets/images/pin4.svg';
import moment from "moment";
import 'moment/locale/pt-br';
import api from '../../../services/api';

export const ModalTimeShifts = ({ handleClose, filter, plantoesAtivos, regionName, plantoesName }) => {

  const [plantoes, setPlantoes] = useState([]);

  useEffect(() => {
    getPlantoes();
  }, []);

  const getPlantoes = async () => {
    const { data } = await api.get(`plantoes/plantoes-ativos`, {
      params: filter
    });
    setPlantoes(data.plantoes);
  }
  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header header-modal-pages">
          <div>
            <img src={clock} />
            <h1>Tempo real</h1>
          </div>
          <div className="data-about">
            <img src={pin3} />
            <h1>{plantoesAtivos}</h1>
            <p>Plantões com algum corretor</p>
          </div>
        </div>
        <div className="box-modal-gray">
          <div className="box-gray-modals">
            <p>{regionName ?? "Brasil"}</p>
          </div>
          <div className="box-gray-modals">
            <img src={pin4} />
            <p>{plantoesName}</p>
          </div>
        </div>
        <div className="dash-modal-body">
          <div className="box-card h-full">
            <div className="box-card-noPadding box-table-shifts">
              <table className="table-dash">
                <thead>
                  <tr className="light-blue">
                    <th>Estado</th>
                    <th>Plantão</th>
                    <th>Corretores no plantão</th>
                  </tr>
                </thead>
                <tbody>
                  {plantoes.map((plantao, key) => (
                    <tr key={key}>
                      <td>{plantao.regional.slug}</td>
                      <td>{plantao.imovel_nome}</td>
                      <td>{plantao.total.corretores}</td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="dash-modal-footer">

        </div>
      </div>
    </div>
  );

}

export default ModalTimeShifts;